import { IValidation, required } from '@vfde-brix/ws10/validation';
import {
    MAX_LENGTH_50_VALIDATION_CONFIG,
    MAX_LENGTH_HOUSE_NUMBER_VALIDATION_CONFIG,
    SECURE_VALUE_VALIDATION_CONFIG,
} from '../../constants';

export const CAPTCHA_VERIFIED = 'mtVerified';
export const CAPTCHA_RENDERED = 'mtRendered';
export const SCRIPT_MTCAPTCHA = 'https://service.mtcaptcha.com/mtcv1/client/mtcaptcha.min.js';
export const SCRIPT_MTCAPTCHA2 = 'https://service2.mtcaptcha.com/mtcv1/client/mtcaptcha2.min.js';

export const CITY_VALIDATOR: IValidation[] = [
    { validator: required, errorKey: 'requiredCity' },
    MAX_LENGTH_50_VALIDATION_CONFIG,
    SECURE_VALUE_VALIDATION_CONFIG,
];

export const STREET_VALIDATOR: IValidation[] = [
    { validator: required, errorKey: 'requiredStreet' },
    MAX_LENGTH_50_VALIDATION_CONFIG,
    SECURE_VALUE_VALIDATION_CONFIG,
];

export const NUMBER_VALIDATOR: IValidation[] = [
    { validator: required, errorKey: 'requiredNumber' },
    MAX_LENGTH_HOUSE_NUMBER_VALIDATION_CONFIG,
    SECURE_VALUE_VALIDATION_CONFIG,
];

export const REGIO_ZUSCHLAG_KEY = 'Regiozuschlag';

export const VF_COOKIE_DOMAIN = '.vodafone.de';

export const ST_COOKIE_DOMAIN = '.wf-de.vodafone.com';

export const ZHP_NO_FIBER_TRIGGER = 'true';
